<template>
    <div>
        <!-- FULLNAME -->
        <span  class="error" v-if="hasError('fullname')">
          {{errors.fullname[0]}}
        </span>
        <div class="form-group">
          <label class="sr-only" for="personal-info-fullname">{{ __('webapp.fullname') }}</label>
          <input
            v-model="sync_fullname"
            id="personal-info-fullname"
            type="text"
            class="form-control"
            :placeholder="__('webapp.fullname')"
            :class="{error: hasError('fullname')}"
            @keyup="clearErrors"
          >
        </div>

        <!-- TEL -->
        <span  class="error" v-if="hasError('mobile')">
          {{errors.mobile[0]}}
        </span>
        <div class="form-group">
          <label class="sr-only" for="personal-info-mobile">{{ __('webapp.mobile') }}</label>
          <input 
            v-model="sync_mobile"
            id="personal-info-mobile"
            type="tel"
            class="form-control"
            :placeholder="__('webapp.mobile')"
            :class="{error: hasError('mobile')}"
            @keyup="clearErrors"
          >
        </div>


        <!-- EMAIL -->
        <span  class="error" v-if="hasError('email')">
          {{errors.email[0]}}
        </span>
        <div class="form-group">
          <label class="sr-only" for="personal-info-email"> email </label>
          <input 
            v-model="sync_email"
            id="personal-info-email"
            type="text"
            class="form-control"
            placeholder="Email"
            :class="{error: hasError('email')}"
            @keyup="clearErrors"
          >
        </div>
    </div>
</template>
<script>


export default {
    data: function(){
      return {
        countryCodeSelector: null,
      };
    },
    methods:{
      clearErrors(){
        if(this.hasErrors)
        this.$emit('clear-errors');
      },

      hasError(field){
        return this.hasErrors && this.errors.hasOwnProperty(field);
      },
      setupIntlTelInput() {
        const phoneInputField = document.querySelector("#personal-info-mobile");

        if (!phoneInputField) return;

        if (this.countryCodeSelector) {
          this.countryCodeSelector.destroy();
          this.countryCodeSelector = null;
        }

        const countryData = window.intlTelInputGlobals.getCountryData();

        this.countryCodeSelector = window.intlTelInput(phoneInputField, {
          initialCountry: this.findIso2ByDialCode(countryData, this.countryCode),
          preferredCountries: [],
          separateDialCode: true,
          utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/23.0.8/js/utils.js",
        });

        phoneInputField.addEventListener('countrychange', () => {
          const countryData = this.countryCodeSelector.getSelectedCountryData();
          this.emitCountryCode(countryData.dialCode);
        });
      },
      emitCountryCode(CountryCode) {
        this.$emit('update:countryCode', CountryCode);
      },
      findIso2ByDialCode(countryData, dialCode) {
        for (let i = 0; i < countryData.length; i++) {
          if (countryData[i].dialCode === dialCode) {
            return countryData[i].iso2;
          }
        }
        this.$emit('update:countryCode', "30");
        return "gr";
      },
    },
    props:{
      fullname: String,
      email: String,
      mobile: String,
      countryCode: String,
      errors: [Array,Object]
    },
    watch: {
      countryCode: {
        handler(newVal, oldVal) {
          this.setupIntlTelInput();
        },
        immediate: true
      }
    },
    computed:{
      hasErrors(){
        return !this.$_.isEmpty(this.errors)
      },
      sync_fullname: {
          get() {
              return this.fullname;
          },
          set(val) {
              this.$emit('update:fullname', val);
          }
      },
      sync_mobile: {
          get() {
              return this.mobile;
          },
          set(val) {
              this.$emit('update:mobile', val);
          }
      },
      sync_email: {
          get() {
              return this.email;
          },
          set(val) {
              this.$emit('update:email', val);
          }
      },
    }
}
</script>

<style scoped>
  span.error{
    color:#dc3545
  }

  input.error{
    border-color:#dc3545
  }

</style>
